module.exports = __webpack_public_path__ + "img/car-1.a94a98eb.jpg";